import { FC } from 'react';
import { BodyStyled } from './style';

const Body: FC = ({ children, ...restProps }) => <BodyStyled {...restProps}>{children}</BodyStyled>;

export default Body;
